<template>
  <v-dialog
    v-model="showModal"
    max-width="600"
    persistent
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <br>
      <h2 class="title-style">
        <v-icon class="icon-style">
          mdi-calendar-clock
        </v-icon> Filter Records
      </h2>
      <v-form>
        <v-container fluid>
          <v-card-text class="text-body-1 text-center">
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="filteringData.firstName"
                  label="First Name"
                  hint="Service provider's first name"
                  persistent-hint
                  outlined
                  dense
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="filteringData.lastName"
                  label="Last Name"
                  hint="Service provider's last name"
                  persistent-hint
                  outlined
                  dense
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <v-datetime-picker
                  v-model="filteringData.checkInTime"
                  label="From"
                  date-format="yyyy-MM-dd"
                  time-format="HH:mm"
                  :text-field-props="{
                    suffix: userTimeZone,
                    class: 'custom-label-color',
                    outlined: true,
                    dense: true,
                  }"
                  :date-picker-props="{
                    headerColor: '#37474F',
                    max: maxStartDate
                  }"
                  :time-picker-props="{
                    headerColor: '#37474F'
                  }"
                >
                  <template v-slot:dateIcon>
                    <v-icon
                      large
                      color="#37474F"
                    >
                      mdi-calendar
                    </v-icon>
                  </template>
                  <template v-slot:timeIcon>
                    <v-icon
                      large
                      color="#37474F"
                    >
                      mdi-alarm
                    </v-icon>
                  </template>
                </v-datetime-picker>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <v-datetime-picker
                  v-model="filteringData.checkOutTime"
                  label="To"
                  :text-field-props="{
                    persistentHint: true,
                    suffix: userTimeZone,
                    outlined: true,
                    dense: true,
                  }"
                  :date-picker-props="{
                    headerColor: '#37474F',
                    min: minEndDate,
                    max: maxStartDate
                  }"
                  :time-picker-props="{
                    headerColor: '#37474F'
                  }"
                >
                  <template v-slot:dateIcon>
                    <v-icon
                      large
                      color="#37474F"
                    >
                      mdi-calendar
                    </v-icon>
                  </template>
                  <template v-slot:timeIcon>
                    <v-icon
                      large
                      color="#37474F"
                    >
                      mdi-alarm
                    </v-icon>
                  </template>
                </v-datetime-picker>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="filteringData.type"
                  :items="possibleTypes"
                  item-text="name"
                  item-value="id"
                  label="Type"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="mt-2"
              color="red darken-3"
              depressed
              default
              @click="cancel()"
            >
              Cancel
            </v-btn>
            <v-spacer />
            <v-btn
              class="mt-2"
              color="#FF3700"
              depressed
              default
              @click="submit()"
            >
              Filter
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </v-dialog>
</template>

<script>
  import moment from 'moment-timezone';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import Constants from 'src/constants';

  export default {
    name: 'RecordFilterDialog',
    components: {
      'centre-spinner': spinner,
    },
    data: () => ({
      filteringData: {
        firstName: null,
        lastName: null,
        checkInTime: null,
        checkOutTime: null,
        type: null,
      },
      possibleTypes: [
        {
          name: 'Contractor',
          id: 'contractor',
        },
        {
          name: 'Visitor',
          id: 'visitor',
        },
        {
          name: 'Staff',
          id: 'staff',
        },
      ],
      showModal: true,
      maxStartDate: moment().format('YYYY-MM-DD'),
      loading: false,
    }),

    computed: {
      minEndDate () {
        return moment(this.filteringData.checkInTime).format('YYYY-MM-DD');
      },
      userTimeZone () {
        var Zone = moment.tz.guess();
        var timezone = moment.tz(Zone).zoneAbbr();
        return timezone;
      },
    },

    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    methods: {
      cancel () {
        this.showModal = false;
      },
      async submit () {
        this.loading = true;
        await this.$store.dispatch('records/fetchFilteredRecordsList', {
          params: this.filteringData,
        }).then(response => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Filtered check-in records fetched successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.loading = false;
          this.showModal = false;
        }).catch(() => {
          this.loading = false;
        });
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 21px;
}
.icon-style {
  color: #37474F;
  font-size: 55px;
  margin-right: 5px;
}
</style>
